module.exports = {
  httpServer: '//member.yuntask.com',
  mainServer: '//m.yuntask.com'
}



// WEBPACK FOOTER //
// ./src/appconfig.js